"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = useRowActions;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var letsachieve_1 = require("../../../../../api/letsachieve");
var constants_1 = require("../../../../../constants/constants");
var routes_1 = require("../../../../../constants/routes");
var label_1 = require("../../../../../controls/label");
var permissions_1 = require("../../../../../hooks/permissions");
var IUser_1 = require("../../../../../interfaces/IUser");
var main_1 = require("../../../../../reducers/slices/main");
// the tier and level tracks underpin progression across the product, so they are not deletable from here
var PROTECTED_TYPES = [constants_1.RewardTrackTypes.TIER_PROGRESSION, constants_1.RewardTrackTypes.LEVEL_PROGRESSION];
function useRowActions() {
    var _this = this;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, letsachieve_1.useDeleteRewardTrackMutation)(), deleteRewardTrack = _a[0], isLoading = _a[1].isLoading;
    var canDelete = (0, permissions_1.usePermission)(IUser_1.IPermissions.REWARD_TRACKS).canDelete;
    var confirmDelete = (0, react_3.useCallback)(function (rewardTrack) {
        dispatch((0, main_1.setContentModal)({
            title: "Confirm deletion of '".concat(rewardTrack === null || rewardTrack === void 0 ? void 0 : rewardTrack.name, "' reward track"),
            content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Deleting this reward track could result in side effects, like your users losing access to this reward track and their progress.", textColor: "text-inputText", center: true }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Are you sure you wish to continue?", textColor: "text-inputText", center: true }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row pt-4 gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "tertiary", size: "sm", isPending: isLoading, onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "danger", size: "sm", isPending: isLoading, onPress: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var error_1;
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                _b.trys.push([0, 2, , 3]);
                                                // invalidating the RewardTrack tag refreshes the list, so there is no follow-up fetch here
                                                return [4 /*yield*/, deleteRewardTrack(rewardTrack._id).unwrap()];
                                            case 1:
                                                // invalidating the RewardTrack tag refreshes the list, so there is no follow-up fetch here
                                                _b.sent();
                                                dispatch((0, main_1.setMessageModal)({ title: "Success!", messages: ["Successfully deleted reward track."] }));
                                                dispatch((0, main_1.setContentModal)(null));
                                                return [3 /*break*/, 3];
                                            case 2:
                                                error_1 = _b.sent();
                                                dispatch((0, main_1.setMessageModal)({
                                                    title: "Something went wrong when deleting your reward track!",
                                                    messages: [(_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) !== null && _a !== void 0 ? _a : "The request was unsuccessful."],
                                                }));
                                                return [3 /*break*/, 3];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); }, children: "Continue" })] })] })),
        }));
    }, [dispatch, deleteRewardTrack, isLoading]);
    var rowActions = (0, react_3.useCallback)(function (rewardTrack) {
        var actions = [
            {
                key: "edit",
                element: ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "secondary", "aria-label": "Edit ".concat(rewardTrack.name), onPress: function () { return navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.REWARD_TRACKS_ROUTE, "/").concat(rewardTrack._id)); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:pencil" }) }, "edit")),
            },
        ];
        if (canDelete && !PROTECTED_TYPES.includes(rewardTrack.reward_track_type)) {
            actions.push({
                key: "delete",
                element: ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "secondary", "aria-label": "Delete ".concat(rewardTrack.name), onPress: function () { return confirmDelete(rewardTrack); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:trash" }) }, "delete")),
            });
        }
        return actions;
    }, [navigate, confirmDelete, canDelete]);
    return { rowActions: rowActions };
}
